export const MODE: any = {
	DRAG: 'dragMode',	// Mano pointer (default).
	DRAW: 'drawMode',	// Cruz con punto en medio.
	DOOR: 'doorMode',	// Mano
	STAIR: 'elevationTool',	// Mano
	ERASE: 'eraseMode',	// Goma.
};